import { useCallback } from 'react'

export const useJackpotsCurrenciesGameIds = () => {
  const getJackpotCurrenciesGameIds = useCallback(jackpots => {
    let jackpotCurrenciesGameIds = {}

    if (jackpots.length !== 0) {
      jackpotCurrenciesGameIds = jackpots.reduce((acc, currentValue) => {
        //placeholder key from firebase also iterable
        currentValue.gameIds &&
          currentValue.gameIds.forEach(gameId => {
            if (acc[gameId]) {
              if (!acc[gameId].currencies.includes(currentValue.currency)) {
                acc[gameId].currencies.push(currentValue.currency.toUpperCase())
              }
            } else {
              acc[gameId] = {
                currencies: [currentValue.currency.toUpperCase()]
              }
            }
          })

        return acc
      }, {})
    }
    return jackpotCurrenciesGameIds
  }, [])

  return { getJackpotCurrenciesGameIds }
}
